import get from 'lodash.get';

const getSentryDSN = (rootState) => get(rootState, 'config.myyola.sentry_dsn_fe_app');

export default getSentryDSN;
